import { type ReactElement, type ReactNode } from "react";

import { cx, styled } from "simplydo/react/styled";

import { ErrorLabel, StyledField } from "./Form.styles";
import type { FormFieldProps } from "./Form.types";

const FormFieldComponent = ({
  children,
  className,
  style,
  disabled,
  error,
  required,
}: FormFieldProps): ReactElement => {
  const errorMessage =
    error && typeof error !== "boolean" ? (error as ReactNode) : null;

  return (
    <StyledField
      className={cx(
        className,
        Boolean(error) && "is-error",
        disabled && "is-disabled",
        Boolean(required) && "is-required",
      )}
      style={style}
    >
      {children}
      {errorMessage ? <ErrorLabel>{errorMessage}</ErrorLabel> : null}
    </StyledField>
  );
};

export const FormField = styled(FormFieldComponent)``;
